/* eslint-disable no-useless-escape */
import { Button, FormControl, Grid, TextField } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { Formik } from "formik";
import React, { useCallback } from "react";
import { object, string } from "yup";
import UploadfileImage from "../../../../components/UploadfileImage";

export default function SocialForm({
    onSubmit = () => {},
    isCreateMode = false,
    contactUsSocialValues = {},
    fileIcon = [],
    setFileIcon = () => {},
}) {
    // function
    const uploadIcon = useCallback(
        file => {
            const reader = new FileReader();
            reader.readAsDataURL(file[0]);
            reader.onload = async evt => {
                setFileIcon([{ id: 1, name: file[0].name, src: evt.target?.result }]);
            };
        },
        [setFileIcon],
    );
    const removeFile = file => {
        setFileIcon(prev => (prev[0]?.id === file[0]?.id ? [] : prev));
    };

    const handleOnSubmit = useCallback(
        (values = {}) => {
            const data = { ...values, icon: fileIcon[0]?.src || "", oldIcon: values?.icon };
            onSubmit(data);
        },
        [onSubmit, fileIcon],
    );

    return (
        <Formik
            validationSchema={object({
                name: string().required("Required."),
                link: string()
                    .matches(
                        /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/g,
                        "ex. https://www.example.com",
                    )
                    .required("Required."),
            })}
            initialValues={contactUsSocialValues}
            onSubmit={handleOnSubmit}>
            {({ values, errors, handleChange, handleSubmit }) => (
                <Grid container spacing={3} className="pt-5 justify-content-center">
                    <Grid item xs={12} md={4}>
                        <p className="mb-2">Icon <span className="text-danger">(40 x 40)</span></p>
                        <UploadfileImage
                            onAcceptedFiles={uploadIcon}
                            previewImages={fileIcon}
                            removeButton={false}
                            removeAll={removeFile}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label>Title</label>
                        <FormControl className="t-form-group-custom w-100">
                            <TextField
                                className={`h-100`}
                                InputProps={{
                                    endAdornment: <Edit />,
                                }}
                                fullWidth
                                size="small"
                                type="text"
                                name="name"
                                label="Title"
                                variant="outlined"
                                value={values?.name}
                                onChange={handleChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                                FormHelperTextProps={{
                                    className: "text-danger position-absolute",
                                    style: { bottom: -25, left: -12 },
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label>Link</label>
                        <FormControl className="t-form-group-custom w-100">
                            <TextField
                                className={`h-100`}
                                InputProps={{
                                    endAdornment: <Edit />,
                                }}
                                fullWidth
                                size="small"
                                type="text"
                                name="link"
                                label="Link"
                                variant="outlined"
                                value={values?.link}
                                onChange={handleChange}
                                error={Boolean(errors.link)}
                                helperText={errors.link}
                                FormHelperTextProps={{
                                    className: "text-danger position-absolute",
                                    style: { bottom: -25, left: -12 },
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3} className="justify-content-md-end">
                            <Grid item sx={12} md={3} lg={2}>
                                <Button onClick={handleSubmit} className="t-btn-primary w-100">
                                    {isCreateMode ? "Create" : "Update"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
}
